var $ = require('jquery');

var searchOverlay   = require('./search-overlay');
var headerDropdown  = require('./modules/header-dropdown');
var listingFilters  = require('./modules/listing-filters');
var sortDropdown    = require('./modules/sort-dropdown');
var taxonomyBadges  = require('./modules/taxonomy-badges');
var toc             = require('./modules/toc');
var readingProgress = require('./modules/reading-progress');
var feedback        = require('./modules/feedback');
var share           = require('./modules/share');
var titleUnderline  = require('./modules/title-underline');
var newsletter      = require('./modules/newsletter');

$(function () {
    searchOverlay.init();      // header live-search overlay

    headerDropdown.init($);    // header categories dropdown (mobile/tablet)
    listingFilters.init($);    // listing: filter panel + sidebar collapse/drawer
    sortDropdown.init($);      // listing: custom sort listbox

    taxonomyBadges.init($);    // cards/meta: "+n" taxonomy overflow popover

    titleUnderline.init();     // cards/featured: sequential hover underline

    readingProgress.init();    // post: scroll progress bar
    toc.init($);               // post: table of contents + scroll-spy
    feedback.init($);          // post: "was this helpful?" widget
    share.init($);             // post: copy-link button
    newsletter.init($);        // newsletter subscription form
});
